// js/core/Dynamics.js
// 動態關卡物件，由 Game 每幀與測試模擬共用（直接改寫傳入的狀態）：
//   currents.osc    — 擺動人潮帶：整條帶上下正弦漂移 { amp, speed, phase }
//   hazards.period  — 紅綠燈病菌：週期亮燈／熄燈（熄燈＝可安全通過）{ period, duty, phase }
//   hazards.patrol  — 巡邏病菌：兩點之間往返 { x0, y0, x1, y1, speed, phase }
//   gates.period    — 閘機：週期開合（開＝可通過）{ period, duty, phase }

export function updateDynamics(currents, hazards, t, gates) {
  for (const c of currents || []) {
    if (!c.osc) continue;
    if (c.baseY === undefined) c.baseY = c.y;
    c.y = c.baseY + Math.sin(t * c.osc.speed + (c.osc.phase || 0)) * c.osc.amp;
  }
  for (const h of hazards || []) {
    if (h.period) {
      const ph = (t + (h.phase || 0)) % h.period;
      h.active = ph < h.period * (h.duty ?? 0.5);
    }
    if (h.patrol) {
      const p = h.patrol;
      const k = (Math.sin(t * p.speed + (p.phase || 0)) + 1) / 2; // 0..1 往返
      h.x = p.x0 + (p.x1 - p.x0) * k;
      h.y = p.y0 + (p.y1 - p.y0) * k;
    }
  }
  for (const g of gates || []) {
    if (!g.period) continue;
    const ph = (t + (g.phase || 0)) % g.period;
    g.active = ph < g.period * (g.duty ?? 0.5);   // active=true＝閘門關閉
  }
}
